export const orderListName = 'orderList';
// 工具弹窗中默认的列表样式
export const defaultStyleListTypes = [
    ['decimal', 'lower-alpha', 'upper-alpha'],
    ['lower-roman', 'upper-roman', 'lower-greek'],
];
export const inputRegex = /^(\d+)\.\s$/;
// list 的 type 属性只支持5种，此为对应的映射
export const listStyleTypeMap = {
    1: 'decimal',
    a: 'lower-alpha',
    A: 'upper-alpha',
    i: 'lower-roman',
    I: 'upper-roman',
};
//# sourceMappingURL=conf.js.map